import { defineStore } from 'pinia';

import IKind from '@/models/kind';

import jsonApi from '@/libs/jsonapi';

const useKind = defineStore('kind', {
  actions: {
    async getAll(
      params: Partial<{
        filters: Partial<{
          'restaurant_id': string;
        }>;
      }> = {},
    ): Promise<IKind[]> {
      const response = await jsonApi.all('filter').get<IKind[]>(params);

      return response.data;
    },
  },
});

export default useKind;
